import { DEFERRED_MOUNT_IDLE_TIMEOUT_MS } from '@/constants/deferredMount';

/**
 * Run `callback` on `requestIdleCallback` when available, else a short timeout.
 * Returns a cancel function.
 */
export function scheduleIdle(
  callback: () => void,
  timeoutMs: number = DEFERRED_MOUNT_IDLE_TIMEOUT_MS,
): () => void {
  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(callback, { timeout: timeoutMs });
    return () => window.cancelIdleCallback(id);
  }

  const id = window.setTimeout(callback, 1);
  return () => window.clearTimeout(id);
}
